import { useRouteError } from "react-router";
import { Button } from "@/components/ui/button";

/**
 * The root route's `errorElement`: what renders when a component throws while
 * rendering. It replaces the whole tree, store provider included, so it reads
 * nothing from Redux and offers the one thing that reliably helps -- a reload.
 */
export default function RouteError() {
  const error = useRouteError();
  const message =
    error instanceof Error ? error.message : "An unexpected error occurred.";

  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-4 bg-background p-6 text-center text-foreground">
      <h1 className="font-serif text-2xl">Something broke</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        The page hit an error it could not recover from. Reloading usually fixes
        it.
      </p>
      <pre className="max-w-md whitespace-pre-wrap break-words font-mono text-xs text-muted-foreground">
        {message}
      </pre>
      <Button onClick={() => window.location.reload()}>Reload</Button>
    </div>
  );
}
